import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { Button } from '../ui/Button';
export function SCWhyChoose() {
  return <section className="bg-black py-[60px] lg:py-[100px]" data-id="element-1900">
      <div className="max-w-[800px] mx-auto px-6 lg:px-8" data-id="element-1901">
        <AnimateOnScroll className="text-center flex flex-col items-center" data-id="element-1902">
          <h2 className="text-[26px] lg:text-[40px] uppercase text-white leading-tight mb-6 font-[600] font-[Poppins,_sans-serif]" data-id="element-1903">
            WHY CHOOSE BE CLINICAL FOR SCULPTRA
          </h2>

          <div className="w-[40px] h-[2px] bg-[#FF1493] mb-10" data-id="element-1904"></div>

          <div className="space-y-6 text-[#B0B0B0] text-[17px] leading-[1.8] font-body mb-10" data-id="element-1905">
            <p data-id="element-1906">
              Choosing Be CLINICAL for dermal fillers means entrusting your care
              to an evidence-based medical and aesthetic clinic serving the San
              Francisco Bay area. Our clinic, founded in 2017 under the
              leadership of Fiona Frie MD, specializes in preventative aging and
              aesthetic enhancements. As a physician-owned and operated
              facility, we prioritize safety, quality and consistency in all of
              our treatments.
            </p>
            <p data-id="element-1907">
              Our expert injectors have a deep understanding of facial anatomy,
              ensuring subtle, natural results from dermal fillers that
              beautifully enhance your unique features. Experience comprehensive
              care and rejuvenation at Be CLINICAL, where we're committed to
              helping you look and feel your best at any age. Schedule your
              complimentary consultation today!
            </p>
          </div>

          <Button variant="primary" size="lg" className="w-full sm:w-auto" data-id="element-1908">
            BOOK CONSULT
          </Button>
        </AnimateOnScroll>
      </div>
    </section>;
}